// @flow
import React from "react";
import "./SharingIconBox.scss";
import {withTranslation} from "react-i18next";
import type {Product} from "../../../models/Product";
import {getShareUrl} from "../../../helper/pageMeta";

export type SharingIconBoxProps = {
	toggleSharingForm: () => void,
	trackShareButtonClick: Product => void,
	product: Product,
}

const SharingIconBox = (props: SharingIconBoxProps) => {
	// canonical product URL when the router mode provides one, the page URL otherwise
	const shareUrl = encodeURIComponent(getShareUrl());
	const shareText = encodeURIComponent(props.product.name);

	return <span className="hpm-sharingIconBox">
		<span className="hpm-before"/>
		<a href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`}
		   onClick={() => props.trackShareButtonClick(props.product)}
		   title="Facebook" className="first" target="_blank" rel="noopener noreferrer">
			Facebook
		</a>
		<a href={`https://twitter.com/intent/tweet?text=${shareText}&url=${shareUrl}`}
		   onClick={() => props.trackShareButtonClick(props.product)}
		   title="Twitter" target="_blank" rel="noopener noreferrer">
			Twitter
		</a>
		<a href={`https://www.linkedin.com/shareArticle?mini=true&title=${shareText}&url=${shareUrl}`}
		   onClick={() => props.trackShareButtonClick(props.product)}
		   title="LinkedIn" target="_blank" rel="noopener noreferrer" className="last">
			LinkedIn
		</a>
		<span className="hpm-after"/>
	</span>;
};

export default withTranslation()(SharingIconBox);
